import React from "react";
import { useTranslation } from "react-i18next";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";

import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

import LightTooltip from "../../../Components/LightTooltip";
import DateTimeMenu from "./DateTimeMenu";

export default function CalendarButton({ timestamp, handleTimestamp }) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "calendar-popover" : undefined;

  return (
    <div>
      <LightTooltip title={t("timeline.buttons.date")}>
        <div>
          <IconButton size="small" style={{ padding: 8 }} onClick={handleClick}>
            <CalendarTodayOutlinedIcon fontSize="small" />
          </IconButton>
        </div>
      </LightTooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <DateTimeMenu
          initTimestamp={timestamp}
          handleTimestamp={handleTimestamp}
          handleClose={handleClose}
        />
      </Popover>
    </div>
  );
}
